import React from 'react'
import { Icon, Typography, makeStyles } from '@material-ui/core'
import { checkIfNeedsRenewalAndShouldBeNotified, checkIfPetIsBanned } from '../../utils'
import { dangers, successes, gray } from '../../utils/colors'

const useStyles = makeStyles(() => ({
	root: {
		flexGrow: 1
	},
	engagementContainer: {
		display: 'flex',
		alignItems: 'center'
	},
	bannedIcon: {
		color: dangers[500],
		fontSize: '0.75rem',
		lineHeight: '0.75rem',
		marginRight: '0.75rem'
	},
	bannedText: {
		color: dangers[500],
		width: '100%',
		display: 'block'
	},
	positiveIcon: {
		color: successes[500],
		fontSize: '0.75rem',
		lineHeight: '0.75rem',
		marginRight: '0.75rem'
	},
	positiveText: {
		color: successes[500],
		width: '100%',
		display: 'block'
	},
	mutedIcon: {
		color: gray[600],
		fontSize: '0.75rem',
		lineHeight: '0.75rem',
		marginRight: '0.75rem'
	},
	mutedText: {
		color: gray[600],
		width: '100%',
		display: 'block'
	}
}))

/**
 *
 * @param {{
 * data: {
 *  household: {
 *    mute_renewal_alert: boolean,
 *    hasUpcomingMemberships: boolean,
 *    used_bar_park: boolean,
 *    used_petcare: boolean,
 *    completed_grooming_visit: boolean,
 *    founding_member: boolean
 *  },
 *  memberships: [{type: string, deactivated: boolean, expired: boolean, end_date: string}],
 *  pets: [{temporary_service_restrictions?: [], permanent_service_restrictions?: []}]
 * }}} data
 * @returns
 */
const Engagement = ({ data }) => {
	if (!data) {
		return null
	}

	const classes = useStyles()
	let bannedFromBarAndPark = false
	let bannedFromPetCare = false
	let bannedFromGrooming = false

	const [needsRenewal, shouldBeNotified] = checkIfNeedsRenewalAndShouldBeNotified(
		data.household,
		data.memberships
	)

	if (data.pets && data.pets.length) {
		bannedFromBarAndPark = data && data.pets && data.pets.some((p) => checkIfPetIsBanned(p, 'Bar & Park'))
		bannedFromPetCare = data && data.pets && data.pets.some((p) => checkIfPetIsBanned(p, 'Daycare & Boarding'))
		bannedFromGrooming = data && data.pets && data.pets.some((p) => checkIfPetIsBanned(p, 'Grooming'))
	}

	const bannedIconClasses = [classes.bannedIcon, 'fas', 'fa-times'].join(' ')
	const positiveIconClasses = [classes.positiveIcon, 'fas', 'fa-seedling'].join(' ')
	const mutedIconClasses = [classes.mutedIcon, 'fas', 'fa-bell-slash'].join(' ')
	const notificationIconClasses = [classes.positiveIcon, 'fas', 'fa-bell'].join(' ')

	return (
		<>
			{(data.household && !data.household.used_bar_park) || bannedFromBarAndPark ? (
				<div className={classes.engagementContainer}>
					<Icon className={bannedFromBarAndPark ? bannedIconClasses : positiveIconClasses} />
					<Typography
						variant="caption"
						className={bannedFromBarAndPark ? classes.bannedText : classes.positiveText}>
						Bar & Park
					</Typography>
				</div>
			) : null}
			{(data.household && !data.household.used_petcare) || bannedFromPetCare ? (
				<div className={classes.engagementContainer}>
					<Icon className={bannedFromPetCare ? bannedIconClasses : positiveIconClasses} />
					<Typography
						variant="caption"
						className={bannedFromPetCare ? classes.bannedText : classes.positiveText}>
						Pet Care
					</Typography>
				</div>
			) : null}
			{(data.household && !data.household.completed_grooming_visit) || bannedFromGrooming ? (
				<div className={classes.engagementContainer}>
					<Icon className={bannedFromGrooming ? bannedIconClasses : positiveIconClasses} />
					<Typography
						variant="caption"
						className={bannedFromGrooming ? classes.bannedText : classes.positiveText}>
						Grooming
					</Typography>
				</div>
			) : null}
			{needsRenewal && (
				<div className={classes.engagementContainer}>
					<Icon className={shouldBeNotified ? notificationIconClasses : mutedIconClasses} />
					<Typography
						variant="caption"
						className={shouldBeNotified ? classes.positiveText : classes.mutedText}>
						Needs Renewal
					</Typography>
				</div>
			)}
		</>
	)
}

export default Engagement
